import { useNavigate } from 'react-router';

import Slideout from './Slideout';

export default function (props) {
  const navigate = useNavigate();

  return <Slideout navigate={navigate} {...props} />;
}
